import React from 'react';
import { useInit } from '../../../Contexts/InitProvider';
import FocusControl from '../../../utils/FocusControl';
import EmailCont from './Components/EmailCont';
import OtpCont from './Components/OtpCont';
import UpdatePassword from './Components/UpdatePassword';
import ForgottenProvider, { useForgotPassword } from './ForgottenProvider';

function PageCont() {
    const { formData, isError, setIsError, showPwdField } = useForgotPassword();
    FocusControl(isError, setIsError, formData);

    if (showPwdField) {
        return <UpdatePassword />;
    }

    if (!!formData.Email && !!formData.Secret) {
        return <OtpCont />;
    }

    return <EmailCont />;
}

function ForgottenPage() {
    const { initInfo } = useInit();
    return (
        <ForgottenProvider>
            <div className="relative w-full h-full ">
                {initInfo?.adminBackground ? (
                    <img
                        src={initInfo?.adminBackground}
                        alt="adminBackground"
                        className="absolute top-0 left-0 w-full h-full object-cover"
                    />
                ) : null}
                <PageCont />
            </div>
        </ForgottenProvider>
    );
}

export default ForgottenPage;
